/**
 * 授权配置
 * @author chenliying
 */
const Config = {
    /**
     * webapi域名配置
     */ 
    originMap: {
        dev: '//up-service.xingyunzhi.cn',
        stage: '//sg-service.pengpengla.com',
        pro: '//service.upliveapps.com'
    },
    /**
     * 获取环境。 env=stage => stage环境; env=pro 或无 => pro线上环境
     */ 
    env: function() {
        return Uplib.url.query('env') || 'pro';
    },
    /**
     *  根据环境获取对应服务域名
     */
    getPrefix: function() {
        let prefix = this.originMap[this.env()];
        
        return prefix;
    },

    getTwitterRequestTokenPath: function() {
        let prefix = this.getPrefix();
        
        return prefix + '/webauth/twitter/requesttoken';
    },

    /**
     * 通过code获取userToken的webapi路径
     */ 
    getUsertokenPath: function() {
        let prefix = this.getPrefix();
        var target = prefix + '/webauth/auth';
        
        return target;
    },
    /**
     * appid配置
     */ 
    upInfoInPlatform: {
        // 微信平台
        'wechat': {
            appid: 'wx78a12cd5f3b2a993',
            appid_stage: 'wx78a12cd5f3b2a993'
        },
        'wechatQrcode': {
            appId: 'wxbe95819b0e7499a9',
            appSecret: 'b34144895076ee00a3c2dd5c9bb2f3cb'
        },
        // fb平台
        'fb': {
            appid: '1698316857098420'
        },
        // 微博
        'weibo': {
            appid: '3739970591'
        },
        google: {
            clientId: '810710132118-nhlomv7vpqsm6v2a0c9lsgkhbpd4c2qo.apps.googleusercontent.com'
        }
    }
};

export default Config;



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/config.js